import { ProfileModel } from '@pukka/api';

const getAvailableRoutes = (permissions: ProfileModel.Response['permissions']) => {
  if (permissions) {
    const permissionsArray = permissions.reduce((memo: string[], permission) => {
      if (permission.is_allowed_for_moka_pay && permission.urls) {
        memo.push(permission.urls[0]);
      }

      return memo;
    }, []);

    return permissionsArray;
  }

  return [];
};

const isDestinationPermitted = (permissions: ProfileModel.Response['permissions'], pathname: string) => {
  const availableRoutes = getAvailableRoutes(permissions);

  return availableRoutes.findIndex((route) => !!pathname.match(route)) > -1;
};

export { isDestinationPermitted };
